import React from "react";
import familyImage from "../../assets/images/whychooseus.png"; 

const WhyChooseUs = () => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-between bg-gradient-to-r from-white to-blue-100 px-6 md:px-20 py-10 font-poppins text-gray-800">
    
      <div className="w-full md:w-1/2 mb-6 md:mb-0">
        <img src={familyImage} alt="Happy Family" className="w-full h-auto" />
      </div>

     
      <div className="w-full md:w-1/2 text-center md:text-left">
        <h2 className="text-2xl md:text-4xl font-extrabold text-[#4b0000] leading-snug">
          <span className="italic text-[#5c1a32]">Why choose </span>
          <span className="text-[#7b003f] font-extrabold">
            Sansar Sadasya E-Commerce Pvt. Ltd.?
          </span>
        </h2>
        <p className="mt-6 text-base md:text-lg leading-relaxed text-black">
          Because we make things easy & time-saving – order, track, and receive
          services seamlessly through our app. We treat every customer like
          family, ensuring quality in every service or meal. Our commitment to
          cleanliness and safety is uncompromised, & we always deliver reliably,
          right on time.
        </p>
      </div>
    </div>
  );
};

export default WhyChooseUs;
